import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import CustomButton from "../Common/CustomButton";
import congrates from "../../Assets/Images/congrats.svg";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";

function CongratsModal({ open, handleClose }) {
  const navigate = useNavigate();
  const modalRef = useRef(null); 

  useEffect(() => {
    if (open) {
      const handleOutsideClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          navigate("/experience");
          handleClose();
        }
      };

      document.addEventListener("mousedown", handleOutsideClick);

      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [open, navigate, handleClose]);

  const handleButtonClick = () => {
    navigate("/experience");
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          p: 3,
        },
      }}
    >
      <DialogContent
        ref={modalRef} 
        sx={{
          textAlign: "center",
          padding: "32px",
          backgroundColor: "#fff",
        }}
      >
        <Box width={"100%"}>
          <img src={congrates} width={"100%"} alt="Congrats" />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            color: theme.colors.text,
          }}
        >
          Congratulations!
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: 4,
            color: theme.colors.textLight,
          }}
        >
          You have taken the first step to your next adventure. Thank you for choosing "Destination Master"
        </Typography>
        <Box sx={{ width: "fit-content", mx: "auto" }}>
          <CustomButton onClick={handleButtonClick}>
          Keep Discovering
          </CustomButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CongratsModal;
